// extracted by mini-css-extract-plugin
module.exports = {"navIco":"nav_navIco__3ZuJA"};